const errors = (state: any = {}, action: any) => {
  switch (action.type) {
    case 'SET_ERRORS':
      if (action.payload) {
        if (action.payload.constructor === Array) {
          return action.payload
        } else if (action.payload.response) {
          if (action.payload.response.data) {
            if (action.payload.response.data.errors) {
              return action.payload.response.data.errors.map(item => {
                return (
                  'There was an error. Reload the page and try again. If problem persists please contact CDHA. (' +
                  item.message +
                  ')'
                )
              })
            }
          }
        }
      }
      return [
        'There was an error. Reload the page and try again. If the problems persists contact CDHA.'
      ]

    case 'DELETE_ERRORS':
      return null
    default:
      return null
  }
}

export default errors
